import { Component, input } from '@angular/core';
import { ControlContainer, FormGroupDirective } from '@angular/forms';

export interface RadioOption<T = string | number> {
  value: T;
  label: string;
  disabled?: boolean;
  helperText?: string;
}

@Component({
  selector: 'app-radio-option-group',
  templateUrl: './radio-option-group.component.html',
  styleUrls: ['./radio-option-group.component.css'],
  viewProviders: [
    {
      provide: ControlContainer,
      useExisting: FormGroupDirective,
    },
  ],
})
export class RadioOptionGroupComponent<T = string | number> {
  readonly controlName = input.required<string>();
  readonly options = input.required<RadioOption<T>[]>();
  readonly groupLabel = input<string>();
  readonly direction = input<'row' | 'column'>('column');
  readonly variant = input<'pill' | 'card'>('pill');
  readonly invalid = input(false);
  readonly touched = input(false);
  readonly errorMessage = input<string>();

  getOptionId(opt: RadioOption<T>, index: number): string {
    const base = this.controlName() ?? 'radio';
    return `${base}-${index}-${String(opt.value)}`;
  }
}
